module.exports = __webpack_public_path__ + "static/media/surgery.60d0c504.svg";